import { useState } from "react";
import { Heart } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { Input } from "../ui/input";
import { FramePicker } from "./Framed";

export const SaveDialog = ({ open, onOpenChange, defaultTitle, frames, full, onConfirm, busy }) => {
  const [title, setTitle] = useState(defaultTitle || "");
  const [says, setSays] = useState("");
  const [frame, setFrame] = useState("wood");
  const [fav, setFav] = useState(false);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-[2rem] max-w-lg bg-[#FFFBF3]" data-testid="art-save-dialog">
        <DialogTitle className="text-3xl font-black text-[#B4471F] font-round">完成作品囉！</DialogTitle>
        <label className="block space-y-1"><span className="text-stone-600 font-bold">作品名稱</span>
          <Input data-testid="art-save-title" value={title} maxLength={40} onChange={(e) => setTitle(e.target.value)} className="h-12 text-lg rounded-xl" />
        </label>
        <label className="block space-y-1"><span className="text-stone-600 font-bold">我想說的話</span>
          <Input data-testid="art-save-says" value={says} maxLength={80} placeholder="例如：這是我最喜歡的大象！" onChange={(e) => setSays(e.target.value)} className="h-12 text-lg rounded-xl" />
        </label>
        <div className="space-y-1"><span className="text-stone-600 font-bold">選一個畫框</span>
          <FramePicker frames={frames} value={frame} onChange={setFrame} full={full} />
        </div>
        <button data-testid="art-save-fav" type="button" onClick={() => setFav(!fav)} className={`h-12 px-5 rounded-full border-2 flex items-center gap-2 font-bold w-fit ${fav ? "bg-pink-100 border-pink-300 text-pink-600" : "bg-white border-stone-200 text-stone-600"}`}>
          <Heart fill={fav ? "currentColor" : "none"} /> {fav ? "已收藏" : "收藏這幅畫"}
        </button>
        <button data-testid="art-save-confirm" disabled={busy} onClick={() => onConfirm({ title, says, frame, favorite: fav })}
          className="h-14 rounded-full bg-[#E2683C] text-white text-xl font-black disabled:opacity-50">{busy ? "保存中…" : "放進我的作品集"}</button>
      </DialogContent>
    </Dialog>
  );
};
